import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin(() => {
  // OneSignal Web SDK 透過 CDN script 載入 (在 nuxt.config 或 index.html 中)
  // 此 plugin 提供 Vue instance 可用的 $OneSignal 存取

  if (!import.meta.client) return

  // OneSignal SDK 會在 window 上掛載，等待其初始化
  const waitForOneSignal = () => {
    return new Promise((resolve) => {
      if (window.OneSignal) {
        resolve(window.OneSignal)
      } else {
        // 監聽 OneSignal 載入
        const checkInterval = setInterval(() => {
          if (window.OneSignal) {
            clearInterval(checkInterval)
            resolve(window.OneSignal)
          }
        }, 100)

        // 30 秒超時
        setTimeout(() => {
          clearInterval(checkInterval)
          console.warn('[OneSignal] SDK not loaded within 30 seconds')
          resolve(null)
        }, 30000)
      }
    })
  }

  return {
    provide: {
      OneSignal: {
        async init(config) {
          const OneSignal = await waitForOneSignal()
          if (!OneSignal) {
            console.error('[OneSignal] SDK not available')
            return
          }

          try {
            await OneSignal.init(config)
            console.log('[OneSignal] Initialized successfully')
          } catch (error) {
            console.error('[OneSignal] Initialization error:', error)
          }
        },

        async login(externalId) {
          const OneSignal = await waitForOneSignal()
          if (!OneSignal) return

          try {
            await OneSignal.login(externalId)
            console.log(`[OneSignal] User logged in: ${externalId}`)
          } catch (error) {
            console.error('[OneSignal] Login error:', error)
          }
        },

        async logout() {
          const OneSignal = await waitForOneSignal()
          if (!OneSignal) return

          try {
            await OneSignal.logout()
            console.log('[OneSignal] User logged out')
          } catch (error) {
            console.error('[OneSignal] Logout error:', error)
          }
        },

        // 直接存取 OneSignal SDK
        async getSDK() {
          return await waitForOneSignal()
        }
      }
    }
  }
})